import { Injectable } from '@angular/core';
import { DataService } from '../network/data.service';

@Injectable()
export class AccountService {

    constructor(private dataService: DataService) {
    }

    public async login(email: string, password: string) {
        let resp :any = await this.dataService.post('account/loginAjax', {email: email, password: password});
        return resp.username;
    }

}
